import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getGMPActionDashboardCount = createApi(`GMPActionDashboardSlice`,"GET");

const GMPActionDashboardSlice = createSlice({
  name: 'GMPActionDashboardSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGMPActionDashboardCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGMPActionDashboardCount.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getGMPActionDashboardCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPActionDashboardSlice.reducer;